import { render, staticRenderFns } from "./ColegiaturasSucursal.vue?vue&type=template&id=e9c4c066&scoped=true"
import script from "./ColegiaturasSucursal.vue?vue&type=script&lang=js"
export * from "./ColegiaturasSucursal.vue?vue&type=script&lang=js"
import style0 from "./ColegiaturasSucursal.vue?vue&type=style&index=0&id=e9c4c066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c4c066",
  null
  
)

export default component.exports